"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _errors = require('shared/errors');
var _CommandError = require('shared/log/CommandError');

/* Checks before a logo upload, and the words for a refusal. The server
 * checks again (type, size, shape) and names its reason; the page shows
 * that reason as it comes, with a capital letter. */

// The most an upload may be (the server's MaxLogoBytes). A picked file can
// be bigger: the crop step exports it smaller (logoCrop.ts).
 const MAX_LOGO_BYTES = 1024 * 1024; exports.MAX_LOGO_BYTES = MAX_LOGO_BYTES
// The largest file the crop step opens, so a browser isn't asked to decode
// something huge; phone photos are well under it.
 const MAX_SOURCE_BYTES = 20 * 1024 * 1024; exports.MAX_SOURCE_BYTES = MAX_SOURCE_BYTES
const LOGO_TYPES = ['image/png', 'image/jpeg']

 const checkLogoFile = (file) => {
  if (!LOGO_TYPES.includes(file.type)) return 'Upload a PNG or JPEG'
  if (file.size > exports.MAX_SOURCE_BYTES) return 'Pick an image of at most 20 MB'
  return null
}; exports.checkLogoFile = checkLogoFile

const sentence = (text) => text.charAt(0).toUpperCase() + text.slice(1)

// The server's own words for a refused upload or save, else a general line.
 const refusalMessage = (e, fallback) => {
  if (e instanceof _errors.RestError && typeof _optionalChain([e, 'access', _ => _.response, 'optionalAccess', _2 => _2.Error]) === 'string' && e.response.Error) {
    return e.response.Error === 'upload is too large' ? 'The file must be at most 1 MB' : sentence(e.response.Error)
  }
  if (e instanceof _CommandError.CommandError && typeof e.Error === 'string' && e.Error) return sentence(e.Error)
  return fallback
}; exports.refusalMessage = refusalMessage

// "name · 480 × 104 · 38 KB", the dimensions when the browser can read them.
 const fileSummary = (file, size) =>
  [file.name, size && `${size.width} × ${size.height}`, `${Math.max(1, Math.round(file.size / 1024))} KB`]
    .filter(Boolean).join(' · '); exports.fileSummary = fileSummary

// The picked file's pixel size, or null where the browser can't decode it.
 const imageSize = (file) =>
  typeof createImageBitmap === 'function'
    ? createImageBitmap(file).then(b => {
      const size = { width: b.width, height: b.height }
      b.close()
      return size
    }).catch(() => null)
    : Promise.resolve(null); exports.imageSize = imageSize
